import { Request, executeRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  console.log('kycDocumentDownload data:', data)
  return data
}

const kycDocumentDownload = (uploadId: string, documentId: string, tokens: any, uploadType: string) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.kycDownload,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      uploadId: uploadId,
      documentId: documentId,
      uploadType: uploadType,
    },
    responseType: 'arraybuffer',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { kycDocumentDownload }
